import { buildFileUrl } from "@/lib/utils/buildFileUrl";

export interface AttachmentFileUrlInput {
  url?: string;
  path?: string;
}

export function getAttachmentFileUrl(
  file: AttachmentFileUrlInput,
): string | null {
  if (file.url && file.url.startsWith("http")) return file.url;
  if (file.path) return buildFileUrl(file.path);
  return null;
}
